var Status;
(function (Status) {
    Status["Ignored"] = "Ignored";
    Status["Invalid"] = "Invalid";
    Status["NotValidated"] = "NotValidated";
    Status["Valid"] = "Valid";
    Status["Validating"] = "Validating";
})(Status || (Status = {}));
export default Status;



// WEBPACK FOOTER //
// ./app/webpack/vendor/formvalidation-1.3.0/dist/es6/core/Status.js